import { LineChartOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

import CrossAnalysisIcon from '@/assets/icons/CrossAnalysisIcon';
import { Flex, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { CHART_TYPE } from '@/entities/chart/model/constants';
import { ChartTypeMap } from '@/features/(charts)/chart-renderer/model/chart-maps';
import useColor from '@/hooks/domain/useColor';
import { radius } from '@/styles/sizes';

type Props = {
  value: CHART_TYPE;
  onChange: (value: CHART_TYPE) => void;
};

const Icon = (props: { type: CHART_TYPE; size: number; color: string }) => {
  switch (props.type) {
    case CHART_TYPE.SINGLE_AXIS:
      return (
        <LineChartOutlined
          style={{ fontSize: props.size, color: props.color }}
        />
      );
    case CHART_TYPE.CROSS_AXIS:
      return (
        <CrossAnalysisIcon
          style={{ fontSize: props.size, color: props.color }}
        />
      );
  }
  return null;
};

const ChartTypeSelect = (props: Props) => {
  const color = useColor();
  const list = ChartTypeMap.toArray();
  return (
    <div className="flex gap-1.5 w-full">
      {list.map((t) => {
        const colorValue =
          props.value === t.value ? color.primary100 : color.gray700;
        return (
          <VFlex
            onClick={() => props.onChange(t.value)}
            key={t.value}
            a="center"
            g={8}
            f={1}
          >
            <ButtonStyle
              isSelected={props.value === t.value}
              a="center"
              j="center"
              g={4}
            >
              <Flex className="icon-container">
                <Icon type={t.value} size={14} color={colorValue} />
              </Flex>
              <Typo type="label3" weight="sb" color={colorValue}>
                {t.label}
              </Typo>
            </ButtonStyle>
          </VFlex>
        );
      })}
    </div>
  );
};

type ButtonStyleProps = {
  isSelected: boolean;
};

const ButtonStyle = styled(Flex)<ButtonStyleProps>`
  width: 100%;
  height: 38px;
  border: 1px solid transparent;
  background-color: ${(props) => props.theme.colors.gray200};
  border-radius: ${radius.token.lg}px;
  cursor: pointer;
  ${({ isSelected }) =>
    isSelected
      ? css`
          border-color: ${(props) => props.theme.colors.primary100};
        `
      : css`
          border-color: transparent;
        `};

  .icon-container {
    font-size: 24px;
  }
`;

export default ChartTypeSelect;
